import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import warningIcon from '@common/images/warning.svg';
import {Icons} from '@learningblocks/exp-constants';
const {AlertLargeSuccess: YesOrientation, AlertLargeFail: NoOrientation} = Icons;

export function OrientationStatusBlock(props) {

  const {t} = useTranslation();

  const setClassName = () => {
    return `${props.className}_status ${
      props.orientation === 180 ?
        'correct' :
        'incorrect'
    }`;
  };

  const getStatus = () => (
    props.orientation === 180 ?
      t('Yes.string') :
      t('No.string')
  );

  const setOrientationStatusIcon = () => {
    return props.orientation === 180 ?
      <YesOrientation className={'status_yes'} style={{fill: "#84BE60"}} /> :
      <NoOrientation className={'status_no'} style={{fill: "#F15D5A"}} />
  };
  
  const status = props.orientation === 180 ? 'yes' : 'no';

  return (
    <div className='controlsModal_content_left_warning'>
      <h5 className='controlsModal_content_left_warningHeading'>
        <img src={warningIcon} alt='' />
        {t("Hint.string")}
      </h5>
      <div className={`orientationStatus_${status}`}>
        <p className={setClassName()}>
          {t("InCorrectOrientation.string")} {getStatus()}
        </p>
        {setOrientationStatusIcon()}
      </div>
    </div>
  );
}

OrientationStatusBlock.propTypes = {
  /**
   * ClassName to set on status warning component
   */
  className: PropTypes.string,
  /**
   * Boolean to set the Microcentrifuge Orientationd Status Yes/No
   */
  orientation: PropTypes.int,
};

OrientationStatusBlock.defaultProps = {};
